import { createReducer, on } from '@ngrx/store';
import { loadFeaturesSuccess } from '../actions/features.actions';
import { FeatureKey } from '@fc-core/feature-flags/feature.model';
export const featuresKey = 'features';

export interface State {
  featuresList: FeatureKey[] | null;
}

export const initialState: State = {
  featuresList: null,
};

export const reducer = createReducer(
  initialState,
  on(loadFeaturesSuccess, (state, action) => ({
    ...state,
    featuresList: action.payload,
  })),
);
export const getFeatures = (state: State) => state.featuresList;
